// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutHeader_root__2SsYs","subHeading":"LayoutHeader_subHeading__3BDv6","heading":"LayoutHeader_heading__22CB8","text":"LayoutHeader_text__2lwh4"};